export const SearchJobRefinement = {
  AREAS_OF_FOCUS: 'areasOfFocus',
  EDUCATION: 'education',
  FUNCTIONS: 'functions',
  JOB_TYPE: 'jobType',
  LOCALE: 'locale',
  LOCATION_TYPE: 'locationType',
  ORG_TYPE: 'orgType',
  PROFESSIONAL_LEVEL: 'professionalLevel',
  RADIUS: 'radius',
  RECENCY: 'recency',
  HAS_SALARY: 'hasSalary',
  SYNONYM_ID: 'synonymId',
} as const;

export const SEARCH_JOBS_REFINEMENT_NAMES = Object.values(SearchJobRefinement);

export type SearchJobsRefinementType =
  (typeof SearchJobRefinement)[keyof typeof SearchJobRefinement];

export const SEARCH_JOB_REFINEMENT_LABELS = Object.defineProperties(
  {},
  {
    [SearchJobRefinement.AREAS_OF_FOCUS]: {
      get: () => getText('Cause Areas'),
      enumerable: true,
    },
    [SearchJobRefinement.EDUCATION]: {
      get: () => getText('Education'),
      enumerable: true,
    },
    [SearchJobRefinement.FUNCTIONS]: {
      get: () => getText('Job Function'),
      enumerable: true,
    },
    [SearchJobRefinement.JOB_TYPE]: {
      get: () => getText('Job Type'),
      enumerable: true,
    },
    [SearchJobRefinement.LOCALE]: {
      get: () => getText('Listing Language'),
      enumerable: true,
    },
    [SearchJobRefinement.LOCATION_TYPE]: {
      get: () => getText('Location Type'),
      enumerable: true,
    },
    [SearchJobRefinement.ORG_TYPE]: {
      get: () => getText('Org Type'),
      enumerable: true,
    },
    [SearchJobRefinement.PROFESSIONAL_LEVEL]: {
      get: () => getText('Experience Level'),
      enumerable: true,
    },
    [SearchJobRefinement.RADIUS]: {
      get: () => getText('Radius'),
      enumerable: true,
    },
    [SearchJobRefinement.RECENCY]: {
      get: () => getText('Recency'),
      enumerable: true,
    },
    [SearchJobRefinement.SYNONYM_ID]: {
      get: () => getText('Job Family'),
      enumerable: true,
    },
  },
) as Record<SearchJobsRefinementType, string>;
